<template>
  <div class="bg-polaris-border h-px -mx-2" />
</template>
